module.exports = __webpack_public_path__ + "img/pittige-koreaanse-speklapjes.6366dfef.jpeg";